<template>
  <div class="bg-white rounded box-shadow p-3">
    <b-modal hide-footer id="field-book-view-modal" size="lg" title="Field Book View">

      <div class="modal-content bg-white rounded box-shadow">
        <table class="table table-centered table-striped">
          <tr>
            <th>Name</th>
            <td>{{ field_book.name }}</td>
          </tr>
          <tr>
            <th>Name Bn</th>
            <td>{{ field_book.name_bn }}</td>
          </tr>
          <tr>
            <th>Father`s Name</th>
            <td>{{ field_book.father_name }}</td>
          </tr>
          <tr>
            <th>Father`s Name Bn</th>
            <td>{{ field_book.father_name_bn}}</td>
          </tr>
          <tr>
            <th>Mother`s Name</th>
            <td>{{ field_book.mother_name }}</td>
          </tr>
          <tr>
            <th>Mother`s Name Bn</th>
            <td>{{ field_book.mother_name_bn }}</td>
          </tr>
          <tr>
            <th>Field Book No.</th>
            <td>{{ field_book.field_book_no}}</td>
          </tr>
          <tr>
            <th>Field Book Sub No.</th>
            <td>{{ field_book.filed_book_sub_no}}</td>
          </tr>
          <tr>
            <th>Book No</th>
            <td>{{ field_book.book_no_desc }}</td>
          </tr>
          <tr>
            <th>Type</th>
            <td>{{ field_book.reference_book_type_desc }}</td>
          </tr>
          <tr>
            <th>Village</th>
            <td>{{ field_book.village_desc }}</td>
          </tr>
          <tr>
            <th>Mouza</th>
            <td>{{ field_book.mouza_desc }}</td>
          </tr>
          <tr>
            <th>Status</th>
            <td>
              <span class="custom-label custom-label-danger" v-if="field_book.status_id == 1">Locked</span>
              <span  v-if="field_book.status_id == 2" >Unlock</span>
            </td>
          </tr>
          <tr>
            <th>Remarks</th>
            <td>{{ field_book.remarks }}</td>
          </tr>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>


export default {
  name: "viewModal",
  props: ['field_book'],
  components: {},
  data() {
    return {

    };
  },

  mounted() {

  },
  methods: {

  },
};
</script>
